import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store/index";
import "./components/common/common.ts";
import "./registerServiceWorker";
import i18n from "./i18n";
import vueHeadful from "vue-headful";

Vue.component("vue-headful", vueHeadful);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
